<template>
  <div class="rules-container">
    <div class="showcase-header">
      <h1 class="rules-title">Playground Rules</h1>
    </div>
    
    <div class="rules-grid">
      <div class="rule-card">
        <h2 class="rule-heading"><strong>Socks are compulsory</strong></h2>
        <p class="rule-text">To maintain hygiene and safety standards in our play area, we kindly require all visitors, both kids and adults, to wear socks at all times. If you've forgotten to bring socks, they can be purchased at the counter for your convenience.</p>
      </div>

      <div class="rule-card">
        <h2 class="rule-heading"><strong>Adults must accompany kids</strong></h2>
        <p class="rule-text">For the safety and enjoyment of all children, we ask that a responsible adult remain with their child during their visit. This helps ensure a secure and supervised environment for everyone.</p>
      </div>

      <div class="rule-card">
        <h2 class="rule-heading"><strong>No outside food and drinks</strong></h2>
        <p class="rule-text">To provide a consistent experience and manage food allergies, we request that no outside food or beverages be brought into the cafe. We offer a variety of delicious options on our menu.</p>
      </div>

      <div class="rule-card">
        <h2 class="rule-heading"><strong>Prams remain outside</strong></h2>
        <p class="rule-text">Due to limited space and to ensure the safety of all our guests, we kindly ask that prams be parked in the designated area outside the cafe. Allowing prams inside can create tripping hazards and climbing risks for little ones. Additionally, this policy helps us maintain a clean and hygienic environment for everyone.</p>
      </div>

      <div class="rule-card">
        <h2 class="rule-heading"><strong>Avoid bringing sharp or unsafe items</strong></h2>
        <p class="rule-text">For the safety of all our guests, we kindly ask that sharp objects, fragile items, or toys with small detachable parts not be brought into the cafe. This helps prevent accidents and keeps our play area safe for children.</p>
      </div>

      <div class="rule-card">
        <h2 class="rule-heading"><strong>Personal belongings are your responsibility</strong></h2>
        <p class="rule-text">While we strive to provide a secure environment, we cannot take responsibility for lost or stolen items. Please keep an eye on your personal belongings during your visit.</p>
      </div>

      <div class="rule-card">
        <h2 class="rule-heading"><strong>Unsafe behaviour is not permitted</strong></h2>
        <p class="rule-text">To ensure everyone's safety and enjoyment, we kindly ask all guests to refrain from any unsafe behaviour, such as running in non-play areas, rough play, or climbing on furniture. Our staff may step in if necessary to maintain a safe environment for all.</p>
      </div>

      <div class="rule-card">
        <h2 class="rule-heading"><strong>Zero tolerance for abusive behaviour</strong></h2>
        <p class="rule-text">We are committed to creating a friendly and respectful space for everyone. Any form of abuse, including verbal or physical aggression toward other guests or staff, will not be tolerated. Guests who do not adhere to this policy may be asked to leave the premises.</p>
      </div>
    </div>
    <priceDisplay />
  </div>
</template>

<script>
import priceDisplay from '@/components/priceDisplay.vue';
export default {
  name: 'RulesPage',
  components: {
    priceDisplay
  }
};
</script>

<style scoped>
.rules-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
  padding-top: 120px;
}

.showcase-header {
  text-align: center;
  margin-bottom: 3rem;
}

.rules-title {
  font-size: 3rem;
  color: #FF8B8B;
  font-weight: bold;
  font-family: 'Lobster';
  position: relative;
  display: inline-block;
  margin-bottom: 0.5rem;
}

.rules-title::after {
  content: '';
  position: absolute;
  width: 50%;
  height: 4px;
  background: linear-gradient(to right, #FFD1D1, #FFE5A3);
  bottom: -10px;
  left: 25%;
  border-radius: 2px;
}

.rules-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
  margin-bottom: 3rem;
}

.rule-card {
  background-color: #fff;
  border-radius: 15px;
  padding: 1.5rem;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
  border-left: 5px solid #FF8B8B;
}

.rule-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.rule-heading {
  color: #FF8B8B;
  font-size: 1.3rem;
  margin-bottom: 1rem;
}

.rule-text {
  color: #583525;
  line-height: 1.6;
  font-size: 1rem;
}

/* 交替颜色 */
.rule-card:nth-child(2n) {
  border-left: 5px solid #FFE5A3;
}

.rule-card:nth-child(2n) .rule-heading {
  color: #FF9800;
}

.rule-card:nth-child(3n) {
  border-left: 5px solid #D6E6F2;
}

.rule-card:nth-child(3n) .rule-heading {
  color: #4682B4;
}

/* 响应式样式 */
@media (max-width: 768px) {
  .rules-container {
    padding: 1rem;
    padding-top: 100px; /* 移动设备上减小顶部内边距 */
  }

  .rules-title {
    font-size: 2.5rem;
  }

  .rules-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  .rule-card {
    padding: 1.2rem;
  }

  .rule-heading {
    font-size: 1.2rem;
  }

  .rule-text {
    font-size: 0.95rem;
  }
}
</style>